import { classicBusinessProjectApprovalsRoute } from '@jira/router-routes__business-approvals-routes/src/classicBusinessProjectApprovalsRoute.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { approvalsPageEntryPoint } from './ui/index.tsx';

export const classicBusinessProjectApprovalsRouteEntry: Route = createEntry(
	classicBusinessProjectApprovalsRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.approvals-view',
		layout: businessProjectLayout,
		skeleton: ThemedLazySkeleton,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: getProjectViewResources(),
		entryPoint: () => approvalsPageEntryPoint,
		supportsPreviewPanel: true,
		supportsProjectTheme: 'full',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
